export const nugmetollanova = {
    id: "nugmetollanova",
    name: { ru: "Нығметолланова Сәния Миржанқызы", kz: "Нығметолланова Сәния Миржанқызы" },
    position: { ru: "Врач спортивной медицины, врач-эндокринолог", kz: "Спорттық медицина дәрігері, дәрігер-эндокринолог" },
    department: "medical-staff",
    image: "/team_photoes/new/Сәния Миржанқызы.svg",
    experience: {
      ru: "6 лет",
      kz: "6 жыл"
    },
    education: {
      ru: "Медицинский университет г. Семей",
      kz: "Семей қаласының медицина университеті"
    },
    specialization: {
      ru: `• Диагностика и лечение заболеваний щитовидной железы
• Ведение пациентов с сахарным диабетом 1 и 2 типа
• Нарушения обмена веществ, гормональные дисбалансы
• Индивидуальный подход и профилактика осложнений`,
      kz: `• Қалқанша без ауруларын диагностикалау және емдеу
• 1 және 2 типті қант диабеті бар науқастарды бақылау
• Зат алмасу бұзылыстары, гормондық тепе-теңдіктің бұзылуы
• Жеке тұлғаға бағдарланған тәсіл және асқынулардың алдын алу`
    },
    certificates: {
      ru: `Профессиональный путь:
• Работала на кафедре эндокринологии Казахского национального медицинского университета им. С.Д. Асфендиярова
• Эндокринолог-диабетолог в клинике сахарного диабета, г. Алматы`,
      kz: `Кәсіби жолы:
• С.Д. Асфендияров атындағы Қазақ ұлттық медициналық университетінің эндокринология кафедрасында жұмыс істеген
• Алматы қаласындағы қант диабеті клиникасында эндокринолог-диабетолог`
    },
    work: {
      ru: `• 2019–2023 — Центр Внутренних Болезней, г. Алматы, врач-эндокринолог.
• 2020–2023 — Медицинский университет им. Асфендиярова, ассистент кафедры.
• 2023–по настоящее время — главный врач клиники Sharlife, г. Астана.
• 2024–по настоящее время — Спортивный Медицинский Центр, г. Астана, врач-эндокринолог.`,
      kz: `• 2019–2023 — Алматы қ., Ішкі аурулар орталығы, эндокринолог дәрігері.
• 2020–2023 — С.Д. Асфендияров атындағы Медициналық университет, кафедра ассистенті.
• 2023–қазіргі уақытқа дейін — Sharlife клиникасының бас дәрігері, Астана қ.
• 2024–қазіргі уақытқа дейін — Спорттық медициналық орталық, Астана қ., эндокринолог дәрігері.`
    }
  };
